import { ObstacleType, BasicObstacle, eBasicObstacleFlag, ObstacleTypeShadow } from "../../../Obstacle";
import { Pool } from "../../../../../Utils/Collections/Pool";
import { CarouselCell, eState as eCarouselState } from "./Carousel";
import { GameWorld } from "../../../GameWorld";
import { Bonus as BasicBonus, BONUS_TYPES, eBonusFlag } from "../../../Bonus";
import { BonusManager } from "../../../../Bonuses/BonusManager";
import { eBonusUID } from "../../../../Bonuses/Bonus";
import { eModelAsset, eSfxSprite } from "../../../../../Game";
import { Character } from "../../../../Player/Character";
import { SoundManager } from "../../../../../Utils/SoundManager";



export const OBSTACLE_TYPES: ObstacleType[] = [
    new ObstacleType(0, eModelAsset.box, 0.01, 0.28, new pc.Vec2(0.28, 0.28), new pc.Vec2(0, 0),
        new ObstacleTypeShadow("shadowBox", new pc.Vec2(0.5, 0.4), [new pc.Vec3(0.03, 0, 0)])),
];



export class ObstacleController {
    private _obstacle: BasicObstacle;

    get cell(): CarouselCell { return this._cell; }
    private _cell: CarouselCell;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(obstacle: BasicObstacle) {
        this._obstacle = obstacle;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cell: CarouselCell): void {
        this._cell = cell;
        cell.obstacle = this._obstacle;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    updateObstacle(): boolean {
        // Aktualizovat pozici prekazky
        let entity = this._obstacle.entity;
        let pos = entity.getLocalPosition();
        let carousel = this._cell.carousel;
        let carouselDir = carousel.settings.dir;
        let cellPos = carousel.getCellWorldPos(this._cell);
        let cellSize = carousel.getCellSize(this._cell);

        pos.x = cellPos + cellSize / 2;
        entity.setLocalPosition(pos);

        // Overit zda je bunka v hernim svete
        if ((carouselDir > 0 && cellPos >= GameWorld.WORLD_WIDTH) || (carouselDir < 0 && cellPos + cellSize <= 0)) {
            this._obstacle.reset();
            this._cell.obstacle = undefined;

            return false;
        }

        // Upravit kolizni obdelnik
        let colRc = this._obstacle.colRect;

        colRc.x = this._obstacle.type.colRect.x;

        if (carouselDir > 0)
            colRc.x = -(colRc.x + colRc.width);

        colRc.x += pos.x;

        return true;
    }
}



export class Obstacle extends BasicObstacle {
    private _controller: ObstacleController;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: ObstacleType) {
        super(type, FREE_OBSTACLES[type.uid]);
        this._controller = new ObstacleController(this);
    }

    //-------------------------------------------------------------------------
    /**
     * Aktivace prekazky
     * @param parent 
     * @param z
     * @param xDir -1 = smer vlevo, 1 = smer vpravo
     * @param x 
     * @param data 
     */
    //-------------------------------------------------------------------------
    activate(parent: pc.Entity, z: number, xDir: number, x: number, data?: any): BasicObstacle {
        super.activate(parent, z, xDir, x, data);
        this._controller.init(data as CarouselCell);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!super.update())
            return false;

        if ((this._flags & eBasicObstacleFlag.destruction) != 0 || this._controller.cell.carousel.state != eCarouselState.shifting)
            return true;

        return this._controller.updateObstacle();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    handlePlCollision(plChar: Character): void {
        super.handlePlCollision(plChar);
        SoundManager.playSound(plChar.player.soundComponent, eSfxSprite.carHit);
    }
}



/**
 * Pooly s volnymi prekazkami. [index typu prekazky]
 */
export const FREE_OBSTACLES: Pool<BasicObstacle>[] = [
    new Pool<Obstacle>(undefined, 0, true, (): Obstacle => { return new Obstacle(OBSTACLE_TYPES[0]); }),
];



export class Bonus extends BasicBonus {
    private _controller: ObstacleController;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: ObstacleType) {
        super(type, FREE_BONUSES[type.uid]);
        this._controller = new ObstacleController(this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(parent: pc.Entity, z: number, xDir: number, x: number, data?: any): BasicObstacle {
        this._controller.init(data as CarouselCell);
        super.activate(parent, z, xDir, x, data);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!super.update())
            return false;

        if ((this._flags & eBonusFlag.pickupFx) == 0) {
            if (!this._controller.updateObstacle()) {
                BonusManager.instance.incMissedBonuses();
                return false;
            }
        }

        return true;
    }
}



export const FREE_BONUSES: Pool<BasicObstacle>[] = [
    new Pool<Bonus>(undefined, 0, true, (): Bonus => { return new Bonus(BONUS_TYPES[eBonusUID.shield]); }),
    new Pool<Bonus>(undefined, 0, true, (): Bonus => { return new Bonus(BONUS_TYPES[eBonusUID.scoreMultiplier]); }),
]